import { 
  GET_PAYMENT_METHODS_REQUEST, 
  GET_PAYMENT_METHODS_SUCCESS, 
  GET_PAYMENT_METHODS_FAILURE,
  GET_STRIPE_CONNECT_REQUEST,
  GET_STRIPE_CONNECT_SUCCESS,
  GET_STRIPE_CONNECT_FAILURE,
  FETCH_PAYMENT_METHODS_REQUEST,
  FETCH_PAYMENT_METHODS_SUCCESS,
  FETCH_PAYMENT_METHODS_FAILURE,
  CREATE_CHECKOUT_SESSION_REQUEST,
  CREATE_CHECKOUT_SESSION_SUCCESS,
  CREATE_CHECKOUT_SESSION_FAILURE
} from '../actions/paymentActions';

const initialState = {
  loading: false,
  error: null,
  paymentMethods: [],
  stripeConnect: null,
  paymentMethodsLoading: false,
  stripeConnectLoading: false,
  isPaymentMethod: false,
  stripeCheckoutUrl: null,
  customerId: null,
  checkoutSessionLoading: false,
  checkoutSessionError: null,
  checkoutSession: null
};

export default function paymentReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PAYMENT_METHODS_REQUEST:
      return { 
        ...state, 
        paymentMethodsLoading: true, 
        error: null 
      };
    
    case GET_PAYMENT_METHODS_SUCCESS:
      return { 
        ...state, 
        paymentMethodsLoading: false, 
        paymentMethods: action.payload.is_payment_method ? (action.payload.message?.data || []) : [],
        isPaymentMethod: action.payload.is_payment_method || false,
        error: null 
      };
    
    case GET_PAYMENT_METHODS_FAILURE:
      return { 
        ...state, 
        paymentMethodsLoading: false, 
        error: action.error,
        paymentMethods: []
      };

    case GET_STRIPE_CONNECT_REQUEST:
      return { 
        ...state, 
        stripeConnectLoading: true, 
        error: null 
      };
    
    case GET_STRIPE_CONNECT_SUCCESS:
      return { 
        ...state, 
        stripeConnectLoading: false, 
        stripeConnect: action.payload.data,
        stripeCheckoutUrl: action.payload.message,
        error: null 
      };
    
    case GET_STRIPE_CONNECT_FAILURE:
      return { 
        ...state, 
        stripeConnectLoading: false, 
        error: action.error,
        stripeConnect: null
      };

    case FETCH_PAYMENT_METHODS_REQUEST:
      return { 
        ...state, 
        paymentMethodsLoading: true, 
        error: null 
      };
    
    case FETCH_PAYMENT_METHODS_SUCCESS:
      return { 
        ...state, 
        paymentMethodsLoading: false, 
        paymentMethods: action.payload.paymentMethods || [],
        customerId: action.payload.customerId || null,
        error: null 
      };
    
    case FETCH_PAYMENT_METHODS_FAILURE:
      return { 
        ...state, 
        paymentMethodsLoading: false, 
        error: action.error,
        paymentMethods: [],
        customerId: null
      };

    case CREATE_CHECKOUT_SESSION_REQUEST:
      return { 
        ...state, 
        checkoutSessionLoading: true, 
        checkoutSessionError: null 
      };
    
    case CREATE_CHECKOUT_SESSION_SUCCESS:
      return { 
        ...state, 
        checkoutSessionLoading: false, 
        checkoutSession: action.payload,
        checkoutSessionError: null 
      };
    
    case CREATE_CHECKOUT_SESSION_FAILURE:
      return { 
        ...state, 
        checkoutSessionLoading: false, 
        checkoutSessionError: action.error,
        checkoutSession: null
      };

    default:
      return state;
  }
}
